/**
 * The **Zuzahlungskennzeichen** of a §302 Abrechnungsfall — Anlage 3 V21,
 * Ziffer 8.1.3 (#1500).
 *
 * One mandatory character, **exactly one value per Abrechnungsfall**, never one
 * per Einheit. It is the whole of what the Kasse learns about the Zuzahlung: the
 * §302 record carries no Zuzahlungsdatum, so this single digit has to say both
 * *whether* the patient owed anything and *whether that changed during the
 * series*.
 *
 * The literal values are the transcription of the published Werteliste and are
 * what a Nutzdatendatei will carry (TM-9539); the identifiers are ours.
 */
export var CopaymentIndicator;
(function (CopaymentIndicator) {
    /** `0` — keine gesetzliche Zuzahlung. Source: § 61 SGB V, the patient is under 18. */
    CopaymentIndicator["NO_STATUTORY_COPAYMENT"] = "0";
    /** `1` — Zuzahlungsbefreit. Source: a § 62 SGB V Befreiung covering the series. */
    CopaymentIndicator["EXEMPT"] = "1";
    /**
     * `2` — keine Zuzahlung trotz schriftlicher Zahlungsaufforderung.
     *
     * ⚠ **Never derived here**, and {@link DerivableCopaymentIndicator} excludes it
     * at the type level. It does not mean "did not pay"; it means "did not pay
     * *despite a written demand*", and so presupposes a recorded, **dated** demand
     * that only the Ist side (TM-9443) can supply. Inferring it from silence or
     * from a lapsed deadline would be a false claim — and §8 Abs. 8 measures the
     * rate of Schlüssel-2 Fälle per practice precisely because the digit is the
     * entire signal.
     */
    CopaymentIndicator["UNPAID_DESPITE_WRITTEN_DEMAND"] = "2";
    /** `3` — Zuzahlungspflichtig. The ordinary case. */
    CopaymentIndicator["LIABLE"] = "3";
    /** `4` — Übergang zuzahlungspflichtig → zuzahlungsfrei within the series. */
    CopaymentIndicator["LIABLE_TO_EXEMPT"] = "4";
    /** `5` — Übergang zuzahlungsfrei → zuzahlungspflichtig within the series. */
    CopaymentIndicator["EXEMPT_TO_LIABLE"] = "5";
})(CopaymentIndicator || (CopaymentIndicator = {}));
//# sourceMappingURL=copayment-indicator.enum.js.map